'use client';

import type { MouseEvent } from 'react';

import LinkButton from '@/components/atoms/LinkButton';
import { Text } from '@/components/atoms/Text';

import { SideNavSection } from '../../types';
import { createNavigableIdForSideNavLink } from '../../utils';

type HomepageSideNavLinkProps = {
  section: SideNavSection;
  isActive: boolean;
  onSelect: (section: SideNavSection) => void;
};

export function HomepageSideNavLink({
  section,
  isActive,
  onSelect,
}: HomepageSideNavLinkProps) {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    onSelect(section);
  };

  return (
    <LinkButton
      noStyles
      href={createNavigableIdForSideNavLink(section)}
      onClick={handleClick}
      aria-current={isActive ? 'location' : undefined}
      classNames={{ root: 'group w-full text-left transition-colors' }}
    >
      <Text
        variant='body-m'
        color={isActive ? 'base-dark-white' : 'gray-dark-500'}
        classNames={{
          wrapper: !isActive ? 'group-hover:text-gray-dark-300' : undefined,
        }}
      >
        {section.tag}
      </Text>
    </LinkButton>
  );
}
